<template>
  <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>Menu</title>
    <path
      d="M1 3v2.794h22V3H1zm0 8.103v2.794h22v-2.794H1zm0 8.103V22h22v-2.794H1z"
      fill-rule="nonzero"
    />
  </svg>
</template>
